<template lang="pug">
a.activities-location-view-button(
  :class="buttonClass"
  @click.prevent.stop="$emit('click')"
)
  i.hi.hi-14(:class="icon")
  | {{ buttonText }} {{ text }}
</template>

<script>
export default {
  name: 'ActivitiesLocationViewButton',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: () => '',
    },
    icon: {
      type: String,
      default: () => 'hi-group-by-rounded',
    },
  },
  emits: ['click'],
  computed: {
    buttonText() {
      return !this.active ? 'View' : 'Hide';
    },
    buttonClass() {
      return {
        'hs-btn': true,
        active: this.active,
      };
    },
  },
};
</script>
